(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-data/error-code-handler/assets/javascripts/helpers/check-player-exclusion.js') >= 0) return;  svs.modules.push('/components/marketplace-data/error-code-handler/assets/javascripts/helpers/check-player-exclusion.js');
"use strict";


const checkPlayerExclusions = callback => {
  svs.accountservices.player_exclusions.hasExclusionOnVertical('sport', data => {
    if (data && data.hasExclusions) {
      callback(data.exclusionInfo);
    } else {
      callback(null);
    }
  });
};
setGlobal('svs.components.marketplaceData.errorCodeHandler.helpers.checkPlayerExclusions', checkPlayerExclusions);

 })(window);